/**
 * Configuration constants for the Promotions Management System
 */

export const CONFIG = {
  // Authentication
  auth: {
    tokenExpiry: '7d',
    cookieName: 'promo_auth_token',
    cookieOptions: {
      httpOnly: true,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'strict',
      maxAge: 7 * 24 * 60 * 60, // 7 days in seconds
      path: '/'
    }
  },

  // Image upload
  image: {
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
    maxSize: 5 * 1024 * 1024, // 5MB
    filenamePrefix: 'promo-banner-'
  },

  // Promotion defaults
  promotion: {
    defaultContactNumber: '7892504742',
    defaultWhatsappMessage: 'Hi, I want to register for {title}.\n\nEvent Details:\n- Date: {dateRange}\n- Venue: {venue}\n- Category: {category}\n\nPlease share registration details.',
    endingSoonDays: 3
  },

  // Categories
  categories: ['Tournaments', 'Workshops', 'Special Events'],

  // KV Keys
  kvKeys: {
    promotion: (id) => `promotion:${id}`,
    index: 'promotions:index'
  },

  // API Response codes
  errorCodes: {
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    UPLOAD_ERROR: 'UPLOAD_ERROR',
    SERVER_ERROR: 'SERVER_ERROR'
  }
};

export default CONFIG;
